// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__AbmXB","name":"ConsentHeader_name__33SJi","birthday":"ConsentHeader_birthday__26zvL","skeleton":"ConsentHeader_skeleton__30whg"};